import { useOrgContextStore } from "components/main/stores/orgContextStore";

/// The org a newly created data source is minted into (D24).
///
/// Read from the active org context, never from the model being edited: every
/// create surface lives in the main app, and a source belongs to the org the
/// person is standing in. `null` lets the server fall back to their personal
/// org, which is the same rule the backfill applies to legacy rows.
export function useMintOrgId(): string | undefined {
  return useOrgContextStore((s) => s.activeOrgId) ?? undefined;
}

/// Display name of the org a create will mint into, for the surfaces that say
/// so out loud. `null` when it cannot be resolved — the caller omits the line
/// rather than guessing.
export function useMintOrgName(): string | null {
  const orgs = useOrgContextStore((s) => s.orgs);
  const activeOrgId = useOrgContextStore((s) => s.activeOrgId);
  return orgs.find((o) => o.org_id === activeOrgId)?.name ?? null;
}
